/**
 * @file environment.ts
 * @version 2.3.0
 * @datetime 2026-09-06T02:35:00+03:00
 * @description Development environment configuration with CouchDB URL, Gemini 3.1 AI API endpoints, Firebase Auth, and ustatmuhasebe API base URL.
 */

const getApiBaseUrl = () => {
  return 'https://tst.ustatmuhasebe.com';
};

export const environment = {
  production: false,
  version: '2.5.0',
  lastUpdated: '2026-09-14T07:15:00+03:00',
  // 1. Canlı Sesli Sohbet (Live API) - Gemini 3.1 (API Key ustat-server.js'den Socket.IO ile anlık istenir)
  aiVoiceLiveConfig: {
    model: 'gemini-3.1',
    wsEndpoint: 'wss://generativelanguage.googleapis.com/ws/google.ai.generativelanguage.v1alpha.GenerativeService.BidiGenerateContent',
  },

  // 2. Normal OCR / Belge Analizi & Sohbet (REST) - Gemini 3.1 Flash (gemini-3.1-flash-lite)
  aiOcrChatConfig: {
    model: 'gemini-3.1-flash-lite',
    endpoint: 'https://generativelanguage.googleapis.com/v1beta/models/gemini-3.1-flash-lite:generateContent',
    fallbackEndpoint: 'https://generativelanguage.googleapis.com/v1beta/models/gemini-3.1-flash-lite-preview:generateContent',
  },
  COUCHDB_URL: 'https://tst.ustatmuhasebe.com/api/couchdb',
  COUCHDB_BASE_URL: 'https://tst.ustatmuhasebe.com/api/couchdb',
  COUCHDB_DATABASE_NAME: 'muhasebe-test',
  COUCHDB_AUTH_HEADER: 'Basic c2FsYWtvOkJtazEyMzQ1',
  get apiBaseUrl() { return getApiBaseUrl(); },
  firebaseConfig: {
    apiKey: 'AIzaSyBgl39zInBETxPZMkeQSEJeAN5Ab1F3XI4',
    authDomain: 'muhasebe-44f46.firebaseapp.com',
    projectId: 'muhasebe-44f46',
    storageBucket: 'muhasebe-44f46.firebasestorage.app',
    messagingSenderId: '59245537112',
    appId: '1:59245537112:web:d0d6066042d409a346e72d',
    measurementId: 'G-17GDNT5PBJ',
  },
};
